import React from 'react'

const EmailCaptureTitle = ({data, category}) => {
	let copy;
	data = data?.allContentfulSiteGlobalData?.edges[0]?.node;

	switch (category) {
		case 'Business':
			copy = data?.v2CommunityBusinessHeading?.v2CommunityBusinessHeading
			break;
		case 'Contributor':
			copy = data?.v2CommunityContributorsHeading?.v2CommunityContributorsHeading
			break;
		case 'Collaborator':
			copy = data?.v2CommunityCollaboratorsHeading?.v2CommunityCollaboratorsHeading
			break;
		case 'Resources':
			copy = "Bloom Season is presented by Mailchimp "
			break;
		default:
			copy = "Bloom Season is presented by Mailchimp"
	}

	return (
		<h3>
			{copy}

			<style jsx>{`
				h3 {
					font-size: 36px;
					font-family: 'Elizeth';
					font-weight: bold;
					margin-bottom: 15px;
				}
			`}</style>
		</h3>
	)
}

export default EmailCaptureTitle
